import styled, { css } from 'styled-components';

import { Typography } from '@/components/Typography';

export const Subheader = styled(Typography)`
  text-align: center;
  text-transform: uppercase;
  line-height: unset;

  ${({ theme }) => css`
    font-family: ${theme.fontFamilies.italianPlate};
    font-size: ${theme.fontSizes.h3Mobile};
    color: ${theme.colors.secondary};
    margin-top: ${theme.spacing(2)};
    margin-bottom: ${theme.spacing(2)};

    ${theme.media.md.up} {
      font-size: ${theme.fontSizes.h3};
      margin-top: ${theme.spacing(6)};
      margin-bottom: ${theme.spacing(4)};
    }
  `}
`;
